import Vue from 'vue'
import VueRouter from 'vue-router'
import Default from '../views/Default.vue'

Vue.use(VueRouter)

VueRouter.prototype.go = function () {
  this.isBack = true
  window.history.go(-1)
}

const routes = [
  {
    path: '/',
    component: Default,
    children: [
      {
        name: 'Home',
        path: '',
        component: () => import('../components/List.vue'),
        meta: {
          title: '新竹縣防災人員教育訓練暨學習履歷',
          keepAlive: true,
        },
      },
      {
        path: 'c-:code',
        component: () => import('../components/Content.vue'),
        meta: {
          title: '新竹縣防災人員教育訓練暨學習履歷',
          keepAlive: false,
        },
      },
      {
        path: 'c-:code/signup',
        component: () => import('../components/Signup.vue'),
        meta: {
          title: '新竹縣防災人員教育訓練暨學習履歷',
          keepAlive: false,
        },
      },
      // {
      //   path: 'signup',
      //   redirect: '/',
      //   children: [
      //     {
      //       path: 'c-:code',
      //       component: () => import('../components/Content.vue'),
      //       meta: {
      //         title: '新竹縣防災人員教育訓練暨學習履歷',
      //         keepAlive: false,
      //       },
      //     },
      //   ],
      // },
      {
        name: 'SearchPage',
        path: 'page:page',
        component: () => import('../components/List.vue'),
        meta: {
          title: '新竹縣防災人員教育訓練暨學習履歷',
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
]

const router = new VueRouter({
  base: '/resume',
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: routes,
})

export default router
